import Work from "../sections/Work";

export default function WorkPage() {
  return (
    <main className="bg-[#0a0a0a] text-white min-h-screen overflow-x-hidden">
      <Work />
    </main>
  );
}
